// Extension points through which optional modules (listed in modules.js) add to the core pages.
// The core never imports a module (DESIGN.md, Integrations).
export default {
  // Ways to sign in that can take over when a page needs sign-in: { available(), signIn(next) }.
  // The first available one is used instead of the sign-in page; signIn(next) leaves the page.
  signInProviders: [],
  actionButton: null,
  notificationSections: [],
  settingsSections: [],
  // Components shown on the sign-in page above the form, and on the account page after its own parts.
  signInSections: [],
  accountSections: [],
  // Tabs of the admin page (/admin) after its own: { key (in the address), title (text tag), component };
  // the tab shows once its component emits `count`.
  adminSections: [],
  // Set by a module where signing out makes no sense (inside WeChat).
  hideSignOut: false,
  // Components on pages meant to be sent to someone (a game, an invitation), given `share`:
  // { kind: 'game' | 'invitation', id, grid, path, viewer, opponent, inviter, offer, arrived }
  // (offer: the page offers sending it now, to the game's creator or the invitation's inviter;
  // arrived: the player has just made it on the create page).
  shareSections: [],
  // The text tag of the create page's invite entry, when a module words it for where the player is.
  createOpponentInviteLabel: null,
};
